import { RealtimeEffort } from "./types";

export interface RealtimeModelOption {
	label: string;
	value: string;
	realtime: {
		provider: "openai" | "google" | "xai" | string;
		model: string;
	};
}

export const REALTIME_MODEL_OPTIONS: readonly RealtimeModelOption[] = [
	{
		label: "openai/gpt-realtime",
		value: "openai/gpt-realtime",
		realtime: { provider: "openai", model: "gpt-realtime" },
	},
	{
		label: "openai/gpt-realtime-1.5",
		value: "openai/gpt-realtime-1.5",
		realtime: { provider: "openai", model: "gpt-realtime-1.5" },
	},
	{
		label: "openai/gpt-realtime-2",
		value: "openai/gpt-realtime-2",
		realtime: { provider: "openai", model: "gpt-realtime-2" },
	},
	{
		label: "openai/gpt-realtime-2.1",
		value: "openai/gpt-realtime-2.1",
		realtime: { provider: "openai", model: "gpt-realtime-2.1" },
	},
	{
		label: "openai/gpt-realtime-mini",
		value: "openai/gpt-realtime-mini",
		realtime: { provider: "openai", model: "gpt-realtime-mini" },
	},
	{
		label: "google/gemini-2.5-flash",
		value: "google/gemini-2.5-flash",
		realtime: { provider: "google", model: "gemini-2.5-flash" },
	},
	{
		label: "xai/default",
		value: "xai/default",
		realtime: { provider: "xai", model: "default" },
	},
] as const;

export const OPENAI_REALTIME_VOICES = [
	"alloy",
	"ash",
	"ballad",
	"coral",
	"echo",
	"sage",
	"shimmer",
	"verse",
	"marin",
	"cedar",
] as const;

export const GOOGLE_REALTIME_VOICES = [
	"Puck",
	"Charon",
	"Kore",
	"Fenrir",
	"Aoede",
	"Zephyr",
	"Leda",
	"Orus",
	"Callirrhoe",
] as const;

export const XAI_REALTIME_VOICES = ["ara", "rex", "sal", "eve"] as const;

export const GPT_LIVE_VOICES = [
	"aster",
	"beacon",
	"cinder",
	"marin",
	"stone",
	"vesper",
] as const;

export const GPT_LIVE_DEFAULT_VOICE = "marin";
export const GPT_LIVE_DEFAULT_REASONING_MODEL = "gpt-5.6-luna";
export const GPT_LIVE_REASONING_MODEL_OPTIONS = [
	GPT_LIVE_DEFAULT_REASONING_MODEL,
] as const;

export function getSupportedVoicesForModel(
	provider?: string,
	model?: string,
): string[] {
	const prov = (provider || "openai").toLowerCase();
	if (prov === "google") {
		return [...GOOGLE_REALTIME_VOICES];
	}
	if (prov === "xai") {
		return [...XAI_REALTIME_VOICES];
	}
	return [...OPENAI_REALTIME_VOICES];
}

export function getDefaultVoiceForModel(
	provider?: string,
	model?: string,
): string {
	const voices = getSupportedVoicesForModel(provider, model);
	return voices[0] || "alloy";
}

export function isVoiceSupportedForModel(
	voice: string | undefined,
	provider?: string,
	model?: string,
): boolean {
	if (!voice) return false;
	const supported = getSupportedVoicesForModel(provider, model);
	return supported.includes(voice);
}
